import ContactForms from "../../../features/contacts/components/ContactForms";
import { useAppDispatch } from "../../../hooks/redux-hooks";
import {
  setFeedbackModal,
  setSuccessMessageModal,
} from "../../../store/slices/main";

const FeedbackModal = () => {
  const dispatch = useAppDispatch();
  return (
    <ContactForms
      onSuccess={() => {
        dispatch(setFeedbackModal(false));
        dispatch(setSuccessMessageModal(true));
      }}
    />
  );
};

export default FeedbackModal;
